<template>
  <div class="content">
 
    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote></Freequote>
        </div>
      </div>
    </transition>
    <div class="carousel">
      <el-carousel indicator-position="outside" height="500px">
        <el-carousel-item v-for="(item,index) in msg3" :key="index">
          <img v-lazy="item.imgurl" oncontextmenu="return false;" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="main">
      <el-radio-group v-model="radio">
        <div class="top">
          <el-radio :label="1" @change="changes()" v-model="radio">
            <div class="sort">
              <div style="margin-top: 33px;">
                <i class="iconfont icon-cailiaopinpai"></i>
              </div>
              <p>
                选材攻略
                <br />MATERIAL SELECTION
              </p>
            </div>
          </el-radio>
          <el-radio :label="2" @change="changes()" v-model="radio">
            <div class="sort">
              <div style="margin-top: 33px;">
                <i class="iconfont icon-kujialeqiyezhan_quanwudingzhishengchan"></i>
              </div>
              <p>
                全屋定制
                <br />CUSTOMIZED
              </p>
            </div>
          </el-radio>
          <el-radio :label="3" @change="changes()" v-model="radio">
            <div class="sort">
              <div style="margin-top: 33px;">
                <i class="iconfont icon-ruanzhuang"></i>
              </div>
              <p>
                软装攻略
                <br />SOFT LOADING
              </p>
            </div>
          </el-radio>
          <el-radio :label="4" @change="changes()" v-model="radio">
            <div class="sort">
              <div style="margin-top: 33px;">
                <i class="iconfont icon-gonglve"></i>
              </div>
              <p>
                基装攻略
                <br />BASIC STRATEGY
              </p>
            </div>
          </el-radio>
        </div>
      </el-radio-group>
      <div class="center">
        <ul>
          <li v-for="(item,index) in mainlist" :key="index">
            <div class="left">
              <p onselectstart="return false;" onselect="document.selection.empty();">{{item.title}}</p>
              <p
                onselectstart="return false;"
                onselect="document.selection.empty();"
              >{{item.introduction}}</p>
              <div class="btn" @click="todetail(item)">查看详情</div>
              <div class="datetime">
                <span style="margin-left:3%;">浏览：{{item.readnum}}</span>
                <span style="float:right;margin-right:10%;">
                  {{item.createtime.substring(0, 4)}}&nbsp;&nbsp;
                  <span
                    style="font-size:26px;"
                  >{{item.createtime.substring(5, 10)}}</span>
                </span>
              </div>
            </div>
            <div class="right" @click="todetail(item)">
              <img :src="item.articlecovermax" alt oncontextmenu="return false;" />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <el-pagination
        :page-size="3"
        small
        :current-page.sync="page"
        @current-change="handlecurrentchange"
        layout=" prev, pager, next"
        :total="datas.totalCount"
      ></el-pagination>
    </div>
    <div>
      <BottomFoot></BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import BottomFoot from "../components/BottomFoot.vue";
import Rightnav from "../components/Rightnav.vue";
import Freequote from "../components/Freequote.vue";
import VDistpicker from "v-distpicker";
import WOW from "wowjs";
import Tpicker from "../components/Tpicker.vue";
export default {
  components: {
 
    BottomFoot,
    Rightnav,
    VDistpicker,
    Freequote,
    Tpicker
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "桔家云、装修案例、装修参考、整装、婚房、单身公寓、装修  效果图、100平、三口之家、儿童房桔家云整装，上千个装修案例实景分享，业主精心总结装修攻略，新中式、简欧、美式等各种风格案例，尽在桔家云整装。"
        }
      ]
    };
  },
  data() {
    return {
      nub: "8",
      cur: 0,
      radio: 1,
      showquote: false,
      topnub: 0,
      mainlist: [],
      datas: [],
      page: 1,
      msg3: [
        { imgurl: require("../assets/images/smzq/xbycj.jpg"), name: "1" },
        { imgurl: require("../assets/images/smzq/dazkj.jpg"), name: "2" },
        { imgurl: require("../assets/images/smzq/rsdys.jpg"), name: "3" },
        { imgurl: require("../assets/images/smzq/dsbjj.jpg"), name: "4" }
      ],
      activeName: "first",
      activeName: "1",
      item: ""
    };
  },
  methods: {
    onChangeProvince(data) {
      this.ruleForm.clientprovince = data.value;
    },
    onChangeCity(data) {
      this.ruleForm.clientcity = data.value;
    },
    onChangearea(data) {
      this.ruleForm.county = data.value;
    },
    handlecurrentchange(size) {
      this.page = size;
      this.changeitem();
    },
    getshow(data) {
      //console.log("data", data);
      this.showquote = data;
    },
    mask() {
      this.showquote = false;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },
    changes: async function() {
      this.page = 1;
      this.changeitem();
    },
    changeitem: async function() {
      let data = {
        page: this.page,
        limit: 3,
        classtype: this.radio,
        title: ""
      };
      let res = await this.exequy.article(data);
      this.datas = res.data.data;
      this.mainlist = this.datas.list;
      // let res=await this.exequy.postfilterselect(data);
    },
    todetail(item) {
      this.$router.push({ path: "/HowDeco", query: { resl: item.id } });
    },
  },
  // beforeRouteLeave(to, from, next) {
  //   if(from.name=="HowDeco"){
  //     from.meta.keepAlive = false;
  //   }else
  //      this.changeitem();
  //   next();
  // },
  created: async function() {
    let self = this;
    self.changeitem();
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    }),
      new WOW.WOW().init();
  }
};
</script>
<style scoped>
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.main {
  width: 1340px;
  margin: 0 auto;
}
.carousel {
  position: relative;
  
}
.carousel >>> .el-carousel__arrow {
  height: 70px;
  width: 70px;
  font-size: 35px;
}
.el-carousel__item img {
  width: 72%;
  height: 100%;
  margin: 0;
}
.el-carousel__item {
  height: 500px;
}
.main >>> .el-radio.is-checked .sort p {
  color: #b31d25;
}
.main >>> .el-radio__input {
  display: none;
}
.carousel >>> .el-carousel__arrow--right {
  right: 100px;
}
.carousel >>> .el-carousel__arrow--left {
  left: 100px;
}
.main >>> .el-radio-group {
  width: 100%;
}
.top {
  width: 100%;
  height: 200px;
  box-shadow: 5px 5px 7px 0px rgba(0, 0, 0, 0.14);
  background: rgba(226, 226, 226, 0.247);
  display: flex;
  justify-content: space-around;
}
.sort {
  width: 100%;
  float: left;
}
.sort div .iconfont {
  font-size: 42px;
}
.sort p {
  margin-top: 4px;
  font-size: 19px;
  font-family: sans-serif;
  line-height: 30px;
  cursor: pointer;
  color: black;
}
.sort p.active {
  color: #b31d25;
}
.main >>> .el-radio__input.is-checked + .el-radio__label {
  color: #b31d25;
}
.btn {
  width: 120px;
  height: 30px;
  background: #b31d25;
  border-radius: 7px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  cursor: pointer;
  float: left;
  margin-top: 3%;
  margin-right: 5%;
}
.datetime {
  margin-top: 2%;
  width: 95%;
  line-height: 34px;
  height: 30px;
  float: left;
  color: rgb(175, 175, 175);
  border-bottom: 1px solid #d2d3d3;
}
.center {
  width: 100%;
  margin: 0 auto;
  margin-top: 2%;
  color: black;
}
.center ul {
  overflow: hidden;
  padding-inline-start: 0px;
  margin: 0 auto;
}
.center ul li {
  list-style: none;
  width: 99.5%;
  height: 345px;
  float: left;
  /* margin-left: 1%; */
  margin-bottom: 2rem;
  box-sizing: border-box;
  padding: 1.5rem;
  border-radius: 2px;
  box-shadow: 5px 5px 7px 0px rgba(0, 0, 0, 0.14);
  background: rgba(226, 226, 226, 0.247);
}
.center ul li img {
  width: 100%;
}
.left {
  width: 51%;
  height: 100%;
  margin-left: 4%;
  float: left;
  text-align: left;
}
.left p:first-child {
  margin: 26px 0 13px 0;
  font-size: 25px;
}
.left p:not(:first-child) {
  margin: 10px 0;
  font-size: 16px;
  line-height: 25px;
}
.right {
  float: right;
  width: 37%;
  height: 100%;
  margin-right: 2%;
  cursor: pointer;
}
.right img {
  height: 100%;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.tab-content >>> .el-carousel__arrow {
  height: 70px;
  width: 70px;
  font-size: 35px;
}
.convention >>> .el-carousel__arrow {
  height: 70px;
  width: 70px;
  font-size: 35px;
}
.form >>> .distpicker-address-wrapper select:first-child {
  width: 222px;
}
.form >>> .distpicker-address-wrapper select:not(:first-child) {
  width: 108px;
}
.convention >>> .el-carousel__indicator {
  width: 55px;
}
.content {
  width: 100%;
}
.el-pagination {
  margin-bottom: 2rem;
}
.content >>> .el-pagination--small .el-pager li {
  color: rgb(156, 156, 156);
  font-size: 20px;
}
.content >>> .el-pager li.active {
  color: #b31d25;
}
.content >>> .el-pagination .btn-next .el-icon,
.content >>> .el-pagination .btn-prev .el-icon {
  font-size: 20px;
}
.content >>> .el-pagination button:hover {
  color: #333;
}
.content >>> .el-pager li {
  padding: 0 10px;
}
</style>
